<template>
  <div class="leftaligned content">
    <template v-if="!game">
      Нет такой игры, проверьте правильность ссылки
    </template>
    <template v-else-if="!ifRegisteredToGame">
      Вы не зарегистрированы на игру, зарегистрироваться?
      <el-button @click="registerToGame">Зарегистрироваться</el-button>
    </template>
    <template v-else-if="gameActive && !gameOver">
      <h1>Текущая игра. Раунд {{round+1}} из {{numRounds}}</h1>
      <h3 class="centered" v-if="!deadline">{{roundName}}</h3>
      <h2 class="centered" v-if="deadline"> До конца раунда осталось {{secondsToDeadline}} секунд</h2>
      <template v-if="roundAcive">
      <div>Вопросы ...</div>
      <div>Только просмотр <el-switch v-model="viewonly" /></div>
      <div v-for="question_id in questions" :key="question_id" class="question">
        <div class="question_id">{{question_id}}</div> 
          <el-input
            v-model="answers[question_id]"
            :name="`answer_{question_id}`"
            :disabled="viewonly"
          />
      </div>
      <div class="submit_area centered">
        <el-button type="success" class="submit_button" @click="submit">Отправить</el-button>
      </div>
      </template>
      <template v-else>
        <div>Раунд пока неактивен. Ожидайте.</div>
        <div>Можете тем временем попить чаю или съесть пироженку</div>
      </template>
    </template>
    <template v-else-if="gameActive && gameOver">
      <h1>Игра окончена</h1>
      <p>Спасибо что играли, ждем на следующих играх</p>
      <p>Финальные результаты и турнирную таблицу можно посмотреть по этой ссылке</p>
    </template>
    <template v-else>
      Игра неактивна. Дождитесь пока организаторы активируют игру
    </template>
  </div>
</template>

<script>
export default {
  name: 'CurrentGame',
  data() {
    return {
      answers: [],
      timerId: null,
      secondsToDeadline: 0,
      viewonly: false
    }
  },
  props: ['id'],
  computed: {
    game() {
      return this.$store.getters.game(this.id);
    },
    team_id() {
      return this.$store.state.user?.team_id
    },
    ifRegisteredToGame() {
      return this.team_id && this.$store.getters.ifTeamRegisteredToGame(this.team_id, this.id);
    },
    currentGameStatus() {
      return this.$store.getters.currentGame;
    },
    round() {
      return this.currentGameStatus.round;
    },
    roundName() {
      return this.game && this.game.rounds[this.round]?.name;
    },
    numRounds() {
      return this.game?.rounds?.length || 0;
    },
    gameOver() {
      return this.round >= this.numRounds;
    },
    questions() {
      return this.game?.rounds?.[this.round].answers.map((_, idx) => idx) || [0];
    },
    roundAcive() {
      return this.currentGameStatus.round_active;
    },
    gameActive() {
      return this.id == this.currentGameStatus.gameid;
    },
    deadline() {
      return this.currentGameStatus.deadline;
    },
    answersFromDB() {
      return this.$store.state.teamAnswers.find(ans => ans.round == this.round)?.answers;
    }
  },
  methods: {
    submit() {
      this.$confirm('Вы отправляете ответы, изменить после этого шага ничего нельзя. Уверены?', 'Внимание', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          this.$store.dispatch('submitAnswers', {
            user_id: this.$store.state.user?.id,
            team_id: this.team_id,
            game_id: this.id,
            round: this.round,
            answers: this.answers,
            ts: Date.now()
          }).then(() => this.$message({type: 'success', message: 'Ответы отправлены на проверку'}))
          .catch(err => this.$message({type: 'error', message: err.message}));
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Отправка отмнена'
          });          
        });
    },
    tick() {
      if(this.deadline) {
        this.secondsToDeadline = Math.max(Math.floor(this.deadline - Date.now() / 1000), 0);
      } else {
        this.secondsToDeadline = '';
      }
      if(!this.viewonly) {
        this.saveDraft();
      }
    },
    saveDraft() {
      if(this.gameActive && this.roundAcive && this.team_id) {
        const user_id = this.$store.state.user?.id;
        if(user_id) {
          this.$store.dispatch('submitAnswers', {
            user_id: user_id,
            team_id: this.team_id,
            game_id: this.id,
            round: this.round,
            answers: this.answers,
            ts: Date.now()
          }).then(() => {})
          .catch(err => console.error('error saving draft', err.message));
        }
      }
    },
    registerToGame() {
      if(this.team_id) {
        this.$store.dispatch('registerToGame', {team_id: this.team_id, game_id: this.id})
          .then(() => {
            this.$message({type: 'success', message: 'Успешно зарегистрировались на игру'});
          })
          .catch(err => this.$message({type: 'warning', message: `Error: ${err.message}`}));
      }
    },
  },
  mounted() {
    if(this.game && this.team_id) {
      if(!this.$store.getters.ifTeamRegisteredToGame(this.team_id, this.id)){
        this.$router.push(`/RegisterToGame/${this.id}`);
      }
    } 
    clearInterval(this.timerId);
    this.timerId = setInterval(() => this.tick(), 1000);
  },
  beforeDestroy() {
    clearInterval(this.timerId);
  },
  watch: {
    answersFromDB:{
      handler(newAnswersVal) {
        if(newAnswersVal && newAnswersVal.length > 0) {
          this.answers = [...newAnswersVal];
        } else {
          this.answers = []
        }
      },
      immediate: true
    },
    team_id: {
      handler(team_id) {
        if(team_id) {
          this.$store.dispatch('initTeamAnswersForGame', {team_id, game_id: this.id});
        }
      },
      immediate: true
    }
  }
}
</script>

<style scoped>
  .content {
    margin: 20px 20px 20px 40px;
  }
  .question {
    font-size: 20px;
    padding: 5px;
    border-radius: 5px;
    margin: 10px;
    display: flex;
  }
  .question_id {
    margin-right: 10px;
    padding-top: 7px;
    width: 20px;
  }
  .submit_area {
    margin-left: 45px;
    margin-top: 20px;
  }
  .submit_button {
    font-size: 25px;
    padding: 10px 20px;
    font-weight: bold;
  }
</style>